import { TableRow } from "@mui/material"
import {ResponsiveCell} from "./ResponsiveCell"

type props = {
    value: string, 
    hasCopyOption?: boolean, 
    route?: string, 
    remBorder?: boolean, 
}

export const ValueRow = ({value, hasCopyOption = false, route, remBorder = false}: props) => {
    return (
        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
            <ResponsiveCell remBorder={remBorder} value={value} hasCopyOption={hasCopyOption} route={route} align="center"/>
        </TableRow>
    )
}